import { apiClient } from './axios';
import { PaginationData } from '../models/paginationData';
import type { NoticeItem, CreateNoticeRequest, UpdateNoticeRequest, NoticeFilterParams } from '../types/notice';

export const noticeApi = {
    getNotices: async (params: NoticeFilterParams) => {
        const result = await apiClient.get<PaginationData<NoticeItem>>('/admin/notices', {
            page: params.page - 1,
            size: params.size,
            ...(params.isActive !== undefined ? { isActive: params.isActive } : {}),
        });
        return { ...result, content: result.content ?? [] };
    },

    create: (data: CreateNoticeRequest) =>
        apiClient.post<NoticeItem>('/admin/notices', data),

    update: (id: number, data: UpdateNoticeRequest) =>
        apiClient.put<NoticeItem>(`/admin/notices/${id}`, data),

    remove: (id: number) =>
        apiClient.deleteNoData(`/admin/notices/${id}`),
};
